import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Hidden from "@material-ui/core/Hidden";
// @material-ui/icons
import Menu from "@material-ui/icons/Menu";
// core components

import styles from "assets/jss/material-dashboard-react/components/headerStyle.js";
import UserNavbarLinks from "./UserNavbarLinks";
import LogoIcon from "assets/icons/care-aid.png";
import { Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  ...styles(theme),
  appBar: {
    ...styles(theme).appBar,
    color: "#555555",
  },
  title: {
    height: 40,
    '& img': {
      maxHeight: 40,
      minWidth: 100
    }
  },
  hidden: {
    opacity: 0,
    pointerEvents: 'none'
  }
}));

const UserNavbar = (props) => {
  const {
    handleDrawerToggle,
    userInfo
  } = props;

  const classes = useStyles();

  const { color } = props;
  const appBarClasses = classNames({
    [" " + classes[color]]: color,
  });

  return (
    <AppBar className={classNames({
        [classes.appBar]: true,
        [appBarClasses]: true
      })}>
      <Toolbar className={classes.container}>
        <div className={classes.flex}>
          {/* Here we create navbar brand, based on route name */}
          <Box className={classes.title}>
            <img src={LogoIcon} />
          </Box>
        </div>
        <UserNavbarLinks userInfo={userInfo} />
        <Hidden smUp implementation="css">
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
          >
            <Menu />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
}

UserNavbar.propTypes = {
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  routes: PropTypes.arrayOf(PropTypes.object),
  userInfo: PropTypes.object
};

export default UserNavbar;
